import React from 'react';

import {
  AutocompleteArrayInput,
  minValue,
  required,
  SelectInput,
} from 'react-admin';

import {
  Grid,
} from '@mui/material';

import NumberInput from '../../layout/inputFields/NumberInput';
import Label from '../../../customFields/Label';

import countries from '../../../constants/countries';
import { timePeriodChoices } from '../../../constants/timePeriods';

const SustainedForeignIpCountry = () => (
  <Grid size={12}>
    <Grid container gap={1}>
      <Grid size={12}>
        <Label
          variant="label"
          title="Lookback period"
          info="How far back the entity must have used only unexpected IP countries for the rule to consider the pattern sustained."
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <NumberInput
          source="ruleParameters.lookbackPeriod.amount"
          fullWidth
          label="Length"
          validate={[required(), minValue(1)]}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SelectInput
          source="ruleParameters.lookbackPeriod.unit"
          choices={timePeriodChoices}
          fullWidth
          label="Unit"
          validate={[required()]}
        />
      </Grid>

      <Grid size={12}>
        <Label
          variant="label"
          title="Expected countries"
          info="The countries the entity is expected to transact from. The rule is triggered when none of the IPs used during the lookback period resolve to one of them."
        />
      </Grid>
      <Grid size={12}>
        <AutocompleteArrayInput
          source="ruleParameters.expectedCountries"
          fullWidth
          label="Countries"
          choices={countries}
          validate={[required()]}
        />
      </Grid>
    </Grid>
  </Grid>
);

export default SustainedForeignIpCountry;
